import { render, staticRenderFns } from "./UpdateWorksheetTrade.vue?vue&type=template&id=5b5788a1&"
import script from "./UpdateWorksheetTrade.vue?vue&type=script&lang=ts&"
export * from "./UpdateWorksheetTrade.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports